import styled from "styled-components"
import { Button } from 'primereact/button'

export const BaseContent = styled.div`
display: flex ;
justify-content: center ;
`

export const Content = styled.div`
@media (min-width: 600px) {
  width: 600px;
}

@media (max-width: 599px) {
  width: 100%;
}
`

export const HomeContent = styled.div`
width: 100%;

.base{
  width: 100% ;
}
`

export const ButtonUsg = styled(Button)`
  margin-top: 64px;
  width: 100%;
  min-width: 295px;
  background-color: var(--green);
  border: 0;

  &.button-usg:hover {
    background-color: #255845;
    border: 0;
  }  
`